import SplitFlap from '../../components/SplitFlap';

const MESSAGES = ["LAUNCH YOUR CAREER", "CUSTOM PORTFOLIOS", "NEXT STOP: HIRED"];
const SUBHEADER = ["WITH TAKEOFF"];
const NUM_CHARS = Math.max(...MESSAGES.map(msg => msg.length));

export default function Hero() {
  return <section className="min-h-screen flex items-center pt-20 pb-16" id="hero">
    <div className="container mx-auto px-6">
      <div className="flex flex-wrap-reverse xl:flex-wrap items-center">
        <div className="w-full xl:w-1/2 mb-10 xl:mb-0">
          <SplitFlap 
            messages={MESSAGES}
            color="white"
            length={NUM_CHARS}
          />
          <br />
          <SplitFlap 
            messages={SUBHEADER}
            color="#FFD700"
            length={NUM_CHARS}
          />
          <br />
          <p className="text-xl text-gray-600 mt-2 mb-8">
            Build a professional portfolio site in minutes and take off into a new chapter of your career.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center">
            <a href="http://editor.readyfortakeoff.app/sign-up" className="btn-primary flex items-center whitespace-nowrap mb-4 sm:mb-0 sm:mr-4 lg:mr-4 md:px-4 lg:px-6">
              GET STARTED <span className="ml-2">→</span>
            </a>
            <p className="text-sm text-gray-500">
              ✨ Free 30-day trial • No credit card required
            </p>
          </div>          
        </div>
        <div className="w-full xl:w-1/2 flex justify-left xl:justify-center mb-8 xl:mb-0">
          <div className="hero-video relative rounded-2xl overflow-hidden bg-gray-800 w-full max-w-xl aspect-video">
            <video 
              className="w-full h-full object-cover"
              autoPlay
              playsInline
              muted
              loop
            >
              <source src="https://images-assets.nasa.gov/video/Ultimate%20Saturn%20V%20Launch%20w%20Enhanced%20Sound/Ultimate%20Saturn%20V%20Launch%20w%20Enhanced%20Sound~orig.mp4#t=37" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  </section>
}